<template>
  <div class="w-full">
    <!-- Loading -->
    <div v-if="loading" class="flex items-center justify-center py-3">
      <Spinning_Loader />
    </div>

    <!-- Empty -->
    <div v-else-if="actions.length === 0" class="text-gray-500 text-xs text-center py-3">
      No prior actions recorded
    </div>

    <!-- Action list (opportunity-scoped: spans all review levels) -->
    <ul v-else class="space-y-2.5">
      <li v-for="a in actions" :key="a.id" class="flex items-start gap-2">
        <!-- Review-level badge (1LR / 2LR / 3LR / Confirm) -->
        <span
          class="mt-0.5 inline-flex items-center justify-center px-1.5 py-0.5 rounded
                 text-[10px] font-semibold bg-primary-50 text-primary-700 shrink-0 min-w-[2.75rem]"
          :title="a.task_type_name || ''"
        >
          {{ a.review_level || '—' }}
        </span>
        <div class="min-w-0 flex-1">
          <div class="text-xs font-medium text-gray-900 truncate">
            {{ a.action_type_name }}<span v-if="a.hcc_code" class="text-gray-400 font-normal"> · HCC {{ a.hcc_code }}</span>
          </div>
          <div class="flex items-center gap-2 mt-0.5 text-[11px] text-gray-500">
            <span class="truncate">{{ a.coder }}</span>
            <span class="text-gray-300">•</span>
            <span class="shrink-0">{{ formatTime(a.created_at) }}</span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios';
import Spinning_Loader from '@/components/widgetcomponents/Viz_Elements/Spinning_Loader.vue';

export default {
  name: 'Coding_Action_History',
  components: { Spinning_Loader },
  props: {
    // Task id; the backend resolves this task's opportunities and returns
    // actions across every review-level task that shares them.
    taskId: { type: Number, required: true },
  },
  data() {
    return {
      actions: [],
      loading: true,
    };
  },
  watch: {
    taskId: { immediate: true, handler() { this.fetchActions(); } },
  },
  methods: {
    async fetchActions() {
      if (!this.taskId) return;
      this.loading = true;
      try {
        const { data } = await axios.get(`/api/coding/${this.taskId}/action-history/`);
        this.actions = data.actions || [];
      } catch (err) {
        console.error('Failed to load action history:', err);
        this.actions = [];
      } finally {
        this.loading = false;
      }
    },
    formatTime(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      const now = new Date();
      const diffMins = Math.floor((now - date) / 60000);
      const diffHours = Math.floor(diffMins / 60);
      const diffDays = Math.floor(diffHours / 24);
      if (diffMins < 1) return 'Just now';
      if (diffMins < 60) return `${diffMins}m ago`;
      if (diffHours < 24) return `${diffHours}h ago`;
      if (diffDays < 7) return `${diffDays}d ago`;
      return date.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: '2-digit' });
    },
  },
};
</script>
